/* eslint-disable indent */
import { useState } from 'react'
import Table from 'react-bootstrap/Table'
import PlayerOnList from './PlayerOnList'
import { calculateActualAge } from '../services/helpfunctions'

const SKILL_SORT_FIELDS = [
  'keeperSkill',
  'defenderSkill',
  'playmakerSkill',
  'wingerSkill',
  'passingSkill',
  'scorerSkill',
  'setPiecesSkill',
]

const PlayerSorter = ({ players, onRemove, teamName }) => {
  const [sortBy, setSortBy] = useState('age') // Oletuksena lajitellaan iän mukaan
  const [sortOrder, setSortOrder] = useState('asc') // Oletuksena nouseva järjestys

  const handleSortChange = criteria => {
    if (sortBy === criteria) {
      // Vaihda järjestys, jos valitaan sama lajitteluperuste
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
    } else {
      // Aseta uusi lajitteluperuste
      setSortBy(criteria)
      setSortOrder(SKILL_SORT_FIELDS.includes(criteria) ? 'desc' : 'asc')
    }
  }

  const sortedPlayers = [...players].sort((a, b) => {
    let compareValue = 0

    // Vertaa valitun lajitteluperusteen mukaan
    switch (sortBy) {
      case 'age': {
        const ageA = calculateActualAge(a)
        const ageB = calculateActualAge(b)
        compareValue =
          ageA.years * 112 + ageA.days - (ageB.years * 112 + ageB.days)
        break
      }
      case 'keeperSkill':
        compareValue =
          (Number(a.playerSkills?.keeperSkill) || 0) -
          (Number(b.playerSkills?.keeperSkill) || 0)
        break
      case 'defenderSkill':
        compareValue =
          (Number(a.playerSkills?.defenderSkill) || 0) -
          (Number(b.playerSkills?.defenderSkill) || 0)
        break
      case 'playmakerSkill':
        compareValue =
          (Number(a.playerSkills?.playmakerSkill) || 0) -
          (Number(b.playerSkills?.playmakerSkill) || 0)
        break
      case 'wingerSkill':
        compareValue =
          (Number(a.playerSkills?.wingerSkill) || 0) -
          (Number(b.playerSkills?.wingerSkill) || 0)
        break
      case 'passingSkill':
        compareValue =
          (Number(a.playerSkills?.passingSkill) || 0) -
          (Number(b.playerSkills?.passingSkill) || 0)
        break
      case 'scorerSkill':
        compareValue =
          (Number(a.playerSkills?.scorerSkill) || 0) -
          (Number(b.playerSkills?.scorerSkill) || 0)
        break
      case 'setPiecesSkill':
        compareValue =
          (Number(a.playerSkills?.setPiecesSkill) || 0) -
          (Number(b.playerSkills?.setPiecesSkill) || 0)
        break
      default:
        break
    }

    // Palauta joko nouseva tai laskeva arvo
    return sortOrder === 'asc' ? compareValue : -compareValue
  })

  return (
    <div style={{ marginBottom: '30px' }}>
      {teamName && (
        <h3
          style={{ color: '#FFFFFF', marginBottom: '10px', marginTop: '20px' }}
        >
          {teamName}
        </h3>
      )}
      <Table striped bordered hover variant="dark" size="sm">
        <thead>
          <tr>
            <th onClick={() => handleSortChange('age')}>Nimi</th>
            <th
              onClick={() => handleSortChange('age')}
              style={{ cursor: 'pointer' }}
            >
              Ikä {sortBy === 'age' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            <th>Erikoisuus</th>
            <th
              onClick={() => handleSortChange('keeperSkill')}
              style={{ cursor: 'pointer' }}
            >
              Maalivahti{' '}
              {sortBy === 'keeperSkill' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            <th
              onClick={() => handleSortChange('defenderSkill')}
              style={{ cursor: 'pointer' }}
            >
              Puolustus{' '}
              {sortBy === 'defenderSkill' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            <th
              onClick={() => handleSortChange('playmakerSkill')}
              style={{ cursor: 'pointer' }}
            >
              Pelinrakennus{' '}
              {sortBy === 'playmakerSkill' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            <th
              onClick={() => handleSortChange('wingerSkill')}
              style={{ cursor: 'pointer' }}
            >
              Laituri{' '}
              {sortBy === 'wingerSkill' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            <th
              onClick={() => handleSortChange('passingSkill')}
              style={{ cursor: 'pointer' }}
            >
              Syöttäminen{' '}
              {sortBy === 'passingSkill' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            <th
              onClick={() => handleSortChange('scorerSkill')}
              style={{ cursor: 'pointer' }}
            >
              Maalinteko{' '}
              {sortBy === 'scorerSkill' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            <th
              onClick={() => handleSortChange('setPiecesSkill')}
              style={{ cursor: 'pointer' }}
            >
              Erikoistilanteet{' '}
              {sortBy === 'setPiecesSkill' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            {onRemove && <th>Poista</th>}
          </tr>
        </thead>
        <tbody>
          {sortedPlayers.map(player => (
            <PlayerOnList
              key={player.id || player.playerId}
              player={player}
              onRemove={onRemove}
            />
          ))}
        </tbody>
      </Table>
    </div>
  )
}

export default PlayerSorter
